import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-download-apk-modal',
  templateUrl: './download-apk-modal.component.html',
  styleUrl: './download-apk-modal.component.scss'
})
export class DownloadApkModalComponent {
  @Input() isVisible: boolean = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();
  apkUrl = environment.qrislyAPKUrl;

  downloadAPK() {
    window.open(this.apkUrl, '_blank');
  }

  closeModal() {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
  }
}
